// Material UI.
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // Points History Modal Styles
    points: {
      textAlign: 'center'
    },
    pointsTitle: {
      fontFamily: 'VisbyCF-Bold',
      fontSize: "24px",
      marginBottom: theme.spacing(2)
    },
    pointsNumber: {
      display: 'flex',
      marginBottom: '30px',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '5px',
      '& div': {
        marginTop: '5px'
      }
    },
    tableWrapper: {
      borderCollapse: 'separate',
      '& .MuiTableHead-root .MuiTableCell-root': {
        backgroundColor: theme.palette.grey[600],
        color: 'white',
        lineHeight: '1rem'
      },
    },
    pointsModalTable: {
      width: 'auto',
      margin: '0 auto',
      tableLayout: 'auto',
      '& .MuiTableCell-root': {
        textAlign: 'center',
        padding: theme.spacing(2),
        fontSize: '1rem'
      },
      '& .MuiTableBody-root .MuiTableCell-root': {
        whiteSpace: 'nowrap'
      }
    },
    pointsModalTableContainer: {
      overflowX: 'auto',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    pointsModalButtonWrapper: {
      marginTop: theme.spacing(2),
      display: 'flex',
      justifyContent: 'flex-end'
    },
    // Modal Styles
    modalOverlay: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 20px',
      [theme.breakpoints.down('sm')]: {
        padding: '20px'
      }
    },
    modalOverlayMobile: {
      padding: '20px'
    },
    modalPaper: {
      padding: theme.spacing(4),
      maxWidth: '800px',
      width: '100%',
      maxHeight: '80vh',
      overflowY: 'auto',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
        maxWidth: '100%',
        maxHeight: '90vh'
      }
    },
    // Points Transactions Table Styles
    Reason: {
      overflowY: 'scroll',
      whiteSpace: 'pre-line',
      maxHeight: '60px',
      maxWidth: '160px'
    }
  }),
);

export default useStyles;
